export const HISTORICAL_MODULE_TABLE_TRANSLATION = {
    'HISTORICAL_MODULE.TABLE.FISCAL_LOSS': 'Pierderi fiscale',
    'HISTORICAL_MODULE.TABLE.AVAILABLE_FISCAL_LOSS': 'Pierdere fiscală disponibilă',
    'HISTORICAL_MODULE.TABLE.FISCAL_LOSS_USAGE': 'Utilizare pierdere fiscală',
    'HISTORICAL_MODULE.TABLE.REPORTABLE_FISCAL_LOSS': 'Pierdere fiscală reportabilă în anii următori',
    'HISTORICAL_MODULE.TABLE.EXCESS_COSTS': 'Costul excedentar al îndatorării/cheltuieli cu dobânzi și pierderi nete din diferențe de curs valutar',
    'HISTORICAL_MODULE.TABLE.DEDUCTED_EXCESS_COSTS': 'Cost excedentar reportat din perioadele anterioare și dedus',
    'HISTORICAL_MODULE.TABLE.DEDUCTIBLE_EXCESS_COSTS': 'Cost excedentar reportat din perioadele anterioare rămas de dedus în perioadele următoare',
    'HISTORICAL_MODULE.TABLE.SPONSORSHIP_EXPENSES': 'Cheltuieli cu sponsorizările/mecenatul/bursele private disponibile pentru utilizare',
    'HISTORICAL_MODULE.TABLE.TAX_CREDIT_USAGE': 'Utilizare credit fiscal',
    'HISTORICAL_MODULE.TABLE.AVAILABLE_SPONSORSHIP_EXPENSES': 'Cheltuieli cu sponsorizările/mecenatul/bursele private disponibile pentru utilizare în perioadele următoare',
    'HISTORICAL_MODULE.TABLE.ACTION.ADD_YEAR': 'Adaugă an',
    'HISTORICAL_MODULE.COLUMN.YEAR': 'An',
    'HISTORICAL_MODULE.COLUMN.MAX_USAGE_YEAR': 'Anul maxim până la care se raportează pierderea',
    'HISTORICAL_MODULE.COLUMN.BASE_VALUES': 'Valori de bază',
    'HISTORICAL_MODULE.COLUMN.VALUE': 'Valoare'
};
